import {merge} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {wsLogout$} from '@/user/auth-ws';
import {contractSnapshotOrders$, contractIncrementalOrders$} from '@/orders-contract/orders-contract';
import type {ws} from '@/types';

type ContractFillsRaw = ws.ContractFillsRaw;

export type Cache = Map<string, ContractFillsRaw>;
type Action = (map: Cache) => Cache;

const snapshotOrdersFills$ = contractSnapshotOrders$.pipe(map(({orders: {fills}}) => fills));
const incrementalOrdersFills$ = contractIncrementalOrders$.pipe(map(({orders: {fills}}) => fills));

const reset$ = wsLogout$.pipe(
  map(() => (cache) => {
    cache.clear();
    return cache;
  })
);

const action$ = merge<[ContractFillsRaw[], ContractFillsRaw[]]>(snapshotOrdersFills$, incrementalOrdersFills$).pipe(
  map((orders) => {
    return function (cache: Map<string, ContractFillsRaw>) {
      orders.forEach((order) => cache.set(order.execID, order));
      return cache;
    };
  })
);

export const contractFillOrdersCache$ = merge<[Action, Action]>(action$, reset$).pipe(
  scan((p, c) => c(p), new Map<string, ContractFillsRaw>())
);
